import GenericBulkUpload from '../../container/DataUploads/RetailerMappingUpload/GenericBulkUpload';
import focusSkuApi from '../../services/apiService/api/focusSkuApi';
import { SAMPLE_FOCUS_SKU_DATA } from '../../assets/filesEncodedDaata/excelData';
import HistoryTable from '../DataUploads/Table';
import { getFocusSkuHistoryThunk } from '../../redux/slices/focusSku/thunk/focusSkuHistoryThunk';
import { useFocusSkuHistorySelector } from './useFocusSkuHistorySelector';
import './focusSkuUpload.scss';

const FocusSkuUpload = () => (
  <div className='customStyles'>
    <GenericBulkUpload
      apiModule={{
        upload: ({ formData, action }) => focusSkuApi.uploadFocusSku({ formData, action }),
        download: () => focusSkuApi.downloadFocusSkuAllExcel(),
        downloadByRequestId: (requestId) => focusSkuApi.downloadFocusSkuByRequestIdExcel(requestId),
        downloadInsertTemplate: () => focusSkuApi.downloadFocusSkuInsertTemplate(),
        downloadDeleteTemplate: () => focusSkuApi.downloadFocusSkuDeleteTemplate(),
      }}
      moduleName="focusSku"
      sampleTemplate={SAMPLE_FOCUS_SKU_DATA}
      labels={{
        uploadButton: 'Upload Focus SKU',
        downloadButton: 'Download Focus SKU',
        templateButton: 'Download Template',
        statusHistory: 'Status History',
        refreshButton: 'Refresh',
        uploadSuccess: 'Successfully Uploaded',
        uploadFail: 'Failed to upload file!',
        downloadSuccess: 'Successfully Downloaded Focus SKU',
        downloadFail: 'Download failed!',
        templateSuccess: 'Successfully Downloaded Template',
        downloadFilePrefix: 'focus_sku_data_',
        templateFilePrefix: 'focus_sku_template_',
        insertTemplateName:'focus_sku_insert_template',
        deleteTemplateName:'focus_sku_delete_template'
      }}
      HistoryTableComponent={HistoryTable}
      historySelector={useFocusSkuHistorySelector()}
      historyThunk={getFocusSkuHistoryThunk}
      historyType="focusSku"
    />
  </div>
);

export default FocusSkuUpload; 